import { Component, Inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent  {

  title = 'fise-consultas';

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer2: Renderer2
  ) {
    this.loadScriptGoogleMaps();
  }
/*
  ngOnInit(): void {
    const reCaptchaElement = document.getElementsByClassName('grecaptcha-badge')[0] as HTMLElement;
    if (reCaptchaElement) {
      reCaptchaElement.style.zIndex = '1000';
    }
  }
*/
  private loadScriptGoogleMaps() {
    let url: string = `https://maps.googleapis.com/maps/api/js?key=${environment.GOOGLE_MAPS_API_KEY}`;
    return new Promise((resolve, reject) => {
      const script = this.renderer2.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      script.text = '';
      script.async = true;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      this.renderer2.appendChild(this.document.body, script);
    })
  }

}
